import React from 'react';
import Typography from '@mui/material/Typography';

const CMCCColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Level</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Identifier</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Domain</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Description</Typography>
      </div>
    </>
  );
};

export default CMCCColumns;
